module.exports = __webpack_public_path__ + "img/72.69b9675a.jpg";